export const awsDriverFileURL =
  'https://liontaxi-image-uploads140306-dev.s3.eu-west-1.amazonaws.com/public/';

export const awsUsersFileURL =
  'https://liontaxi-users-image24243-dev.s3.eu-central-1.amazonaws.com/public/';

const getCookie = (key) => {
  const allCookies = document.cookie.split(';');

  const cookie = allCookies.filter((cookie) => {
    return cookie.indexOf(key) !== -1;
  });

  return cookie.length >= 1 && cookie[0].trim().split('=')[1];
};

const setCookie = (key, value) => {
  document.cookie = `_${key}_=${value};path=/`;
};

const deleteCookie = (key) => {
  const date = new Date(1970, 1, 1);
  document.cookie = `_${key}_=; expires=${date.toUTCString()}; path=/`;
  document.cookie = `_${key}_=; expires=${date.toUTCString()}; path=/admin`;
};

const stateUtils = { setCookie, getCookie, deleteCookie };
export default stateUtils;

const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const date = new Date();
const year = date.getFullYear();
const thisMonth = date.getMonth();
const thisDay = date.getDate();

export const formattedDate = `${months[thisMonth]} ${thisDay}, ${year}`;
export const formattedMonth = months[thisMonth];

export const getTodaysRides = (bookingDays) => {
  const formattedDays = bookingDays.map((day) => {
    return +day.slice(-4, -2);
  });
  const today = formattedDays.filter((day) => {
    return day === thisDay;
  });
  return today.length;
};

export const getThisMonthsRides = (bookingMonths) => {
  const thisMonths = bookingMonths.filter((month) => {
    return month === months[thisMonth];
  });
  return thisMonths.length;
};

export const timestampFormat = (timestamp) => {
  const date = timestamp.split('T')[0];
  const dateSubs = date.split('-');

  const year = dateSubs[0];
  const month = +dateSubs[1];
  const day = +dateSubs[2];

  return {
    createdAt: `${months[month - 1]} ${day}, ${year}`,
    month,
  };
};
